export const money = (n: number, currency = 'USD') =>
    new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
    }).format(n);

export const formatMoneyForThermal = (n: number, currency = 'USD') => {
    const formatted = new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(n);
    return `${formatted} ${currency}`;
};
